import { render, staticRenderFns } from "./TrabalhoListModal.vue?vue&type=template&id=07482db7&scoped=true"
import script from "./TrabalhoListModal.vue?vue&type=script&lang=js"
export * from "./TrabalhoListModal.vue?vue&type=script&lang=js"
import style0 from "./TrabalhoListModal.vue?vue&type=style&index=0&id=07482db7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07482db7",
  null
  
)

export default component.exports